<template>
  <div class="mt-16 bg-white bg-opacity-60 min-h-screen pb-20 h-full">
    <div class="flex items-center justify-start bg-beige-academy-250 w-full py-2
      text-white">
      <div class="text-base lg:text-lg w-full px-10 lg:px-56 font-sans-serif flex">
        <router-link class="pr-1" to="/teacher-dashboard/classrooms">
          {{$t('classrooms.classrooms')}}
        </router-link>
        / <span class="pl-2"> {{$t('template.templates')}} </span>
      </div>
    </div>
    <div class="flex w-full lg:w-3/4 justify-center items-center mt-10 mx-auto relative text-black">
      <h1 class="text-base lg:text-2xl text-center justify-self-center self-center w-full
      uppercase">
        {{$t('template.title')}}
      </h1>
      <router-link class="font-bold rounded-full mx-2 transform hover:scale-110
      font-sans-serif text-beige-academy-500 z-30 absolute right-0"
      @click="$modal.show('add-tier')" :to="$route.fullPath+'/new'">
        <plus-icon class="bg-white rounded-full w-8" />
      </router-link>
    </div>

    <div class="flex flex-col w-11/12 lg:w-1/2 mx-auto mt-10">
      <template-card
        class="mt-10"
        v-for="template in templates"
        :key="template.id"
        :template="template"
        @delete="deleteTemplate(template)" />
    </div>

    <modal resizable name="cannot-delete" height="auto" :adaptive="true">
      <cannot-delete
        @close="$modal.hide('cannot-delete')"
        :sentence="$t('template.cannotDelete')" />
    </modal>

    <modal resizable name="sure-to-delete" height="auto" :adaptive="true">
      <are-you-sure-to-delete
        @delete="sureDeleteTemplate"
        @close="$modal.hide('sure-to-delete')"
        v-if="templateToDelete"
        :question="$t('template.delete')+templateToDelete.description+'?'"
        :isLoading="isLoading" />
    </modal>

  </div>
</template>

<script>
import PlusIcon from '@/components/graphics/PlusIcon.vue';
import { getTeacherTemplates } from '@/services/TeacherService';
import { mapGetters } from 'vuex';
import TemplateCard from '@/components/teachers/TemplateCard.vue';
import axios from 'axios';
import AreYouSureToDelete from '../components/modals/AreYouSureToDelete.vue';
import CannotDelete from '../components/modals/CannotDelete.vue';

export default {
  components: {
    PlusIcon,
    TemplateCard,
    AreYouSureToDelete,
    CannotDelete,
  },

  data() {
    return {
      templates: [],

      templateToDelete: null,

      isLoading: false,
    };
  },

  computed: {
    ...mapGetters({
      user: 'auth/user',
    }),
  },

  created() {
    this.getTemplates();
  },

  methods: {
    getTemplates() {
      getTeacherTemplates(this.user.teacher.id).then(({ data }) => {
        this.templates = [];
        this.templates = data;
      });
    },

    deleteTemplate(template) {
      if (template.hasTiers) {
        this.$modal.show('cannot-delete');
        return;
      }
      this.templateToDelete = template;
      this.$modal.show('sure-to-delete');
    },

    sureDeleteTemplate() {
      this.isLoading = true;
      axios.delete(`/api/classroom-templates/${this.templateToDelete.id}`).then(() => {
        this.$modal.hide('sure-to-delete');
        this.isLoading = false;
        this.getTemplates();
      });
    },

  },
};
</script>
